import {GetterTree} from "vuex";
import {
    IPortalTimelineItem,
    IPortalTimelineWidgetLabels,
    IPortalTopic,
    PortalTimelineWidgetState
} from "@/apps/PortalTimelineWidget/models/portal-timeline-widget-state";

export default <GetterTree<PortalTimelineWidgetState, PortalTimelineWidgetState>>{
    getItems(state): IPortalTimelineItem[] {
        return state.items;
    },
    getLabels(state): IPortalTimelineWidgetLabels {
        return state.labels;
    },
    getSelectedItem: (state) => (index: number) => {
        return state.items[index];
    },
    getSelectedItemIndex(state): Number {
        return state.selectedItemIndex;
    },
    getSelectedTopic(state): IPortalTopic {
        return state.selectedTopic;
    }
}
